import type { ReactNode } from "react";

export function ErrorLayout({ children }: Readonly<{ children?: ReactNode }>) {
  return (
    <div className="bg-primary-200 grid min-h-screen grid-rows-[20px_1fr_20px] items-center justify-items-center p-8 pb-20">
      <div className="row-start-2 pb-24">
        <div className="mt-8 rounded-lg border border-gray-200 bg-white p-8 shadow-lg">
          <div className="flex flex-col justify-center gap-4">{children}</div>
        </div>
      </div>
    </div>
  );
}
